module.exports = __webpack_public_path__ + "img/symbol_10.5f3b68b1.png";